/*
** $Id$
**
** Copyright 2018 Port25 Solutions, Inc.
** All rights reserved.
*/

// Polyfill for Internet Explorer support.
// See https://github.com/facebook/create-react-app/blob/master/CHANGELOG.md
// specifically, "Breaking Changes" under "Migrating from 1.x to 2.0.3"
import 'react-app-polyfill/ie9'; // For IE 9-11 support

import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

ReactDOM.render(<App />, document.getElementById('root'));
